// extracted by mini-css-extract-plugin
export default {"bottomNav":"Residents_bottomNav__mtb-o","navButton":"Residents_navButton__uOr7I","active":"Residents_active__WjYK2"};